export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./matchDetail.vue?vue&type=template&id=3a721efc&"


//////////////////
// WEBPACK FOOTER
// ./src/views/match/matchDetail.vue?vue&type=template&id=3a721efc&
// module id = null
// module chunks = 